export default (idade, idadeMinima, idadeMaxima) => {

    if (idade === null) return null

    const idadeMinimaAnos = idadeMinima / 12
    const idadeMaximaAnos = idadeMaxima / 12

    return idadeMinimaAnos <= idade && idadeMaximaAnos >= idade
}